import { allModifiers, controlCharsObject, keywordAndModifierRegex, keywords, keywordsObject } from "@quickpoint.me/shared";

// this cleans up the content ot avoid and mismatches due to extra spaces etc.
const imageOrColorKeywordParser = (code: string): string[] => {
  const parseFor = [
    keywordsObject["audio:"].keyword,
    keywordsObject["background:"].keyword,
    keywordsObject["chart:"].keyword,
    keywordsObject["image:"].keyword,
  ];
  if (!code) {
    // console.info("empty code passed to parser");
    return [];
  }
  const parsed: string[] = [];
  const lines = code.split("\n");
  let content: string;

  for (const line of lines) {
    const keywordModifierMatch = line.match(keywordAndModifierRegex);
    if (keywordModifierMatch?.[2]) {
      const type = keywordModifierMatch[2];
      content = keywordModifierMatch[3 + keywords.length + allModifiers.length];
      content = content.replace(type, "");
      content = content.trim();
      const splits = content.split(controlCharsObject["|"].controlChar);
      //@ts-expect-error
      if (parseFor.includes(type)) {
        parsed.push(...splits);
      }
    }
  }
  return [...new Set(parsed)];
};

export default imageOrColorKeywordParser;
